import { Bars3Icon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <>
      <header className="relative flex flex-col md:flex-row justify-between items-center px-5 py-4">
        <div className="flex flex-col items-center md:items-start w-full md:w-auto">
          <Link to="/" className="Rubik-Bold text-2xl text-primary">
            Aram EyeCare
          </Link>
          <h1 className="animated-slogan text-lg text-gray-700 mt-1 text-center md:text-left">
            Eye care that cares for you...
          </h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:block">
          <ul className="flex text-primary YsabeauSC text-2xl gap-5">
            <li className="hover:bg-gray-300 rounded px-2 py-1">
              <Link to="/" className="hover:text-primary">Home</Link>
            </li>
            <li className="hover:bg-gray-300 rounded px-2 py-1">
              <Link to="/product" className="hover:text-primary">Products</Link>
            </li>
            <li className="hover:bg-gray-300 rounded px-2 py-1">
              <Link to="/blog" className="hover:text-primary">Blogs</Link>
            </li>
            <li className="hover:bg-gray-300 rounded px-2 py-1">
              <Link to="/about" className="hover:text-primary">About Us</Link>
            </li>
          </ul>
        </nav>
        {/* Mobile Menu Toggle Button */}
        <button
          onClick={() => setToggleMenu(!toggleMenu)}
          className="absolute right-5 top-4 block md:hidden z-50"
        >
          <Bars3Icon className="text-primary h-6" />
        </button>

        {/* Mobile Sidebar Navigation */}
        {toggleMenu && (
          <nav
            className="fixed top-0 right-0 h-full w-3/4 md:hidden bg-white shadow-lg transition-transform duration-300 ease-in-out z-40"
          >
            <div className="p-4 border-b flex items-center justify-between">
              <h2 className="text-xl font-bold text-primary">Menu</h2>
              <button
                onClick={() => setToggleMenu(false)}
                className="bg-black text-white text-xl p-2 rounded-full inline-flex items-center justify-center"
              >
                <span>×</span>
              </button>
            </div>
            {/* Navigation items in column format */}
            <ul
              onClick={() => setToggleMenu(false)}
              className="flex flex-col text-primary YsabeauSC text-xl p-4 gap-4"
            >
              <li className="hover:bg-gray-300 rounded px-2 py-1">
                <Link to="/" className="hover:text-primary block">Home</Link>
              </li>
              <li className="hover:bg-gray-300 rounded px-2 py-1">
                <Link to="/product" className="hover:text-primary block">Products</Link>
              </li>
              <li className="hover:bg-gray-300 rounded px-2 py-1">
                <Link to="/blog" className="hover:text-primary block">Blogs</Link>
              </li>
              <li className="hover:bg-gray-300 rounded px-2 py-1">
                <Link to="/about" className="hover:text-primary block">About Us</Link>
              </li>
            </ul>
          </nav>
        )}
      </header>
      {/* Horizontal Line */}
      <hr className="border-t-2 border-black" />
    </>
  );
}